
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {sancionStore} from "@/store/sancionStore";
  import {http} from "@/config/HttpClient";
  import {DateTime} from "luxon";
  import {SancionService} from "@/services/SancionService";
  import {Alert} from "@/addons/Alert";
  import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
  import SancionNew from "@/views/sanciones/SancionNew.vue";
  import SancionShow from "@/views/sanciones/SancionShow.vue";

  @Component({
    name: "SancionObservar",
    //components: {FacturaHistorial}
  })
    export default class extends Vue {
    @Prop() isOservar!: boolean
    @Prop() sancion!: any

    private sancionStore = sancionStore();
    private sancionService = SancionService.getInstance();
    valid = false
      private observacion = null;

    $refs!: {
      form: HTMLFormElement,
      txtCuenta: HTMLInputElement,
    };

    observarSancion() {
        if (!this.$refs.form.validate()) {
          return;
        }
      const data = {sancionId: this.sancion.id, observacion: this.observacion}
      this.sancionService.baja(data);
      this.$emit('listar');
      this.$emit('close');
      }
    }


